import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Box,
  Typography,
  Divider,
} from '@mui/material';
import { taskPropType } from './kanbanTaskConstants';

export default function KanbanTaskAnnotationModal({ open, task, onClose, onAddNote }) {
  const [newNote, setNewNote] = useState('');

  useEffect(() => {
    if (open) setNewNote('');
  }, [open]);

  const handleAddNote = () => {
    if (!newNote.trim()) return;
    onAddNote(newNote.trim());
    setNewNote('');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Anotações {task ? `— ${task.title}` : ''}</DialogTitle>
      <DialogContent dividers>
        {task && task.notes && task.notes.length > 0 ? (
          <Stack spacing={1.5} sx={{ mb: 2 }}>
            {task.notes.map((note) => (
              <Box key={note.id}>
                <Typography variant="body2">{note.text}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {note.date}
                </Typography>
                <Divider sx={{ mt: 1 }} />
              </Box>
            ))}
          </Stack>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Nenhuma anotação registrada ainda.
          </Typography>
        )}

        <TextField
          label="Nova anotação"
          value={newNote}
          onChange={(event) => setNewNote(event.target.value)}
          placeholder="Ex: Aguardando retorno do fornecedor."
          fullWidth
          multiline
          minRows={2}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
        <Button variant="contained" onClick={handleAddNote} disabled={!newNote.trim()}>
          Adicionar anotação
        </Button>
      </DialogActions>
    </Dialog>
  );
}

KanbanTaskAnnotationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  task: taskPropType,
  onClose: PropTypes.func.isRequired,
  onAddNote: PropTypes.func.isRequired,
};

KanbanTaskAnnotationModal.defaultProps = {
  task: null,
};
